import React from 'react';
import ResetPasswordForm from '../components/auth/ResetPasswordForm';
import { useAuth } from '../contexts/AuthContext';
import { Navigate } from 'react-router-dom';

const ResetPasswordPage = () => {
  const { isAuthenticated } = useAuth();

  // 如果未登录，重定向到登录页面
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="flex items-center justify-center min-h-[calc(100vh-8rem)]">
      <div className="w-full max-w-md">
        <ResetPasswordForm />
      </div>
    </div>
  );
};

export default ResetPasswordPage;
